import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DatePicker from "react-datepicker";
import { LichSuGiaHan } from "./LichSuGiaHan";
import NhanVayApi from "service/nhanVayApi";
import { pushNotification } from "utils/notifications";
import { useSelector, useDispatch } from "react-redux";
import { getListNhanVay, updateDataSearch } from "../../../../actions/NhanVay/";
import { currentDate } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { getDate } from "utils/formatDate";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

export const ModalGiaHanNgayTra = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  const dispatch = useDispatch();

  const initDataGiaHan = {
    NhanVayId: props.NhanVayId,
    TenChuNo: "",
    SoTienVay: 0,
    TienPhaiThu: 0,
    NgayVay: currentDate(),
    KyHan: currentDate(),
    NgayGiaHan: currentDate(),
    LyDoGiaHan: "",
  };
  const [dataGiaHan, setDataGiaHan] = useState(initDataGiaHan);

  //Lấy chi tiết gia hạn
  useEffect(() => {
    LayThongTinGiaHan();
  }, []);

  const LayThongTinGiaHan = () => {
    NhanVayApi.getChiTietGiaHanNgayTra(props.NhanVayId).then((response) => {
      setDataGiaHan({
        ...dataGiaHan,
        NhanVayId: props.NhanVayId,
        TenChuNo: response.data.TenChuNo,
        SoTienVay: response.data.SoTienVay,
        TienPhaiThu: response.data.PhaiThu,
        NgayVay: getDate(response.data.NgayVay),
        KyHan: getDate(response.data.KyHan),
        NgayGiaHan: dataGiaHan.NgayGiaHan,
        LyDoGiaHan: dataGiaHan.LyDoGiaHan,
      });
    });
  };

  const updateTextValue = (field) => (e) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: e.target.value,
    });
  };
  const onChangeNumber = (field, value) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: convertToNumber(value),
    });
  };

  const onChangeDate = (field) => (evt) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors({
        ...errors,
        NgayGiaHan: "Nhập ngày gia hạn",
      });
      // NgayThanhToan.current.focus();
    } else {
      setErrors({
        ...errors,
        NgayGiaHan: "",
      });
    }
  };

  const onChangeDate1 = (field) => (evt) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: evt,
    });
  };

  const updateTextValue1 = (field) => (e) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: e.target.value,
    });
    if (e.target.value.length === "") {
      setErrors1({
        ...errors1,
        LyDoGiaHan: "Nhập lý do gia hạn",
      });
      LyDoGiaHan.current.focus();
    } else {
      setErrors1({
        ...errors1,
        LyDoGiaHan: "",
      });
    }
  };
  //Thông báo
  const initErrors = {
    NgayGiaHan: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    LyDoGiaHan: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const LyDoGiaHan = React.createRef();
  const onSubmit = () => {
    // Validate

    if (dataGiaHan.LyDoGiaHan === "") {
      setErrors1({
        ...errors1,
        LyDoGiaHan: "Nhập lý do gia hạn",
      });
      LyDoGiaHan.current.focus();
      return;
    } else if (
      dataGiaHan.NgayGiaHan === "null" ||
      dataGiaHan.NgayGiaHan === null ||
      dataGiaHan.NgayGiaHan === ""
    ) {
      setErrors({
        ...errors,
        NgayGiaHan: "Nhập ngày gia hạn",
      });
      return;
    } else {
      //  setRefreshing(true);
      NhanVayApi.giaHanNgayTra(
        dataGiaHan.NhanVayId,
        dataGiaHan.TienPhaiThu,
        dataGiaHan.NgayVay,
        dataGiaHan.KyHan,
        dataGiaHan.NgayGiaHan,
        dataGiaHan.LyDoGiaHan
      ).then((response) => {
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          pushNotification(
            "Gia hạn kỳ trả thành công",
            "success",
            "TOP_CENTER",
            1000
          );
          props.onHide();
          dispatch(getListNhanVay(dataSearch));
        }
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-document-edit"></i>
          </span>
          Gia hạn ngày trả
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse669"
                className="card-header border-info"
                href="#collapse669"
                aria-expanded="true"
                aria-controls="collapse669"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>
                    Gia hạn nợ phải trả nhận vay (Kỳ gia hạn: {dataGiaHan.KyHan}
                    )
                  </h3>
                </a>
              </div>
              <div
                id="collapse669"
                aria-labelledby="headingCollapse669"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content mt-1">
                  <div className="card-body">
                    <div className="form-body row">
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="col-sm-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Họ và Tên chủ nợ"
                              disabled="disabled"
                              value={dataGiaHan.TenChuNo}
                            ></TextInputOnRow>
                          </div>

                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="label-control color7-bold">Ngày vay</label>

                              <DateTimePicker
                                value={convertDate(dataGiaHan.NgayVay)}
                                name="NgayVay"
                                readOnly={true}
                              ></DateTimePicker>
                            </div>
                          </div>

                          {/* <div className="col-sm-3">
                            <TextInputOnRow
                              labelClass="label-control"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Ngày vay"
                              disabled="disabled"
                              value={dataGiaHan.NgayVay}
                            ></TextInputOnRow>
                          </div> */}

                          <div className="col-sm-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Số tiền vay"
                              disabled="disabled"
                              value={formatNumber(dataGiaHan.SoTienVay)}
                            ></TextInputOnRow>
                          </div>

                          <div className="col-sm-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Phải thu"
                              disabled="disabled"
                              value={formatNumber(dataGiaHan.TienPhaiThu)}
                            ></TextInputOnRow>
                          </div>

                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                className="label-control color7-bold"
                                for="projectinput2"
                              >
                                Gia hạn nợ đến ngày
                              </label>

                              <DateTimePicker
                                value={convertDate(dataGiaHan.NgayGiaHan)}
                                onChange={onChangeDate("NgayGiaHan")}
                                name="NgayGiaHan"
                              ></DateTimePicker>
                            </div>
                            {errors.NgayGiaHan && (
                              <span className="canh-bao-red">
                                {errors.NgayGiaHan}
                              </span>
                            )}
                          </div>

                          <div className="col-sm-9">
                            <div className="form-group">
                              <label
                                className="label-control color7-bold"
                                for="projectinput2"
                              >
                                Lý do
                              </label>
                              <textarea
                                id="projectinput8"
                                rows="1"
                                className="form-control input-sm text-era"
                                name="comment"
                                placeholder=""
                                value={dataGiaHan.LyDoGiaHan}
                                onChange={updateTextValue1("LyDoGiaHan")}
                                ref={LyDoGiaHan}
                              ></textarea>
                            </div>
                            {errors1.LyDoGiaHan && (
                              <span className="canh-bao-red">
                                {errors1.LyDoGiaHan}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <LichSuGiaHan NhanVayId={props.NhanVayId} />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={onSubmit}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Xác nhận
        </button>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
